import { Card } from '@cmsgov/ds-medicare-gov'
import { Button } from 'components/Button/Button'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PreventiveService } from '@cms-max/medicare-api-sdk'
import { getFormalDate } from 'utils/date'

export interface PreventiveServiceCardProps {
  service: PreventiveService,
  className?: string
}

export const PreventiveServiceCard: FC<PreventiveServiceCardProps> = ({ service, className }) => {
  const { t, i18n } = useTranslation('preventiveServices')
  const {
    serviceType,
    availableDate,
    detailsUrl
  } = service
  // TODO: switch over to MyLink component line 42
  return (
    <Card className={className}>
      <div className="ds-l-row">
        <div className="ds-l-sm-col--6 ds-l-md-col--4 ds-l-lg-col--5 ds-l-xl-col--5 ds-l-col--12">
          <dl className='my-c-service-card-info'>
            <dt className='ds-u-padding-left--5'>
              {t('serviceType')}
            </dt>
            <dd>{serviceType}</dd>
          </dl>
        </div>
        <div className="ds-l-sm-col--6 ds-l-md-col--4 ds-l-lg-col--4 ds-l-xl-col--4 ds-l-col--12">
          <dl className='my-c-service-card-info'>
            <dt className='ds-u-padding-left--5'>
              {t('availableDate')}
            </dt>
            <dd>{getFormalDate(availableDate, i18n.language)}</dd>
          </dl>
        </div>
        <div className="ds-l-md-col--4 ds-l-lg-col--3 ds-l-xl-col--3 ds-l-col--12">
          <div className='ds-u-padding--3 ds-u-visibility--hidden-print'>
            <Button
              data-testid='get-service-details'
              className='ds-c-button ds-c-button--primary-alt'
              aria-label={`${t('detailsButtonAria')} ${serviceType}`}
              href={detailsUrl}
              siteActivityProps={{
                core: {
                  component: 'Preventive Services',
                  elementId: `ps_getdetails_click`,
                  coreClickData: {
                    linkText: t('getDetails'),
                    linkUrl: detailsUrl
                  }
                }
              }}
              target='_blank'>
              {t('getDetails')}
            </Button>
          </div>
        </div>
      </div>
    </Card>
  )
}
